// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// รันบน localhost → ใช้ API บนเครื่อง (Bizsoft-Api รันที่ http://localhost:5000)
const isLocalhost = ['localhost', '127.0.0.1'].includes(location.hostname);

export const environment = {
  production: false,
  //apiURL: 'https://localhost:44340',
  appURL: 'https://app-dev.bizflow.in.th',
  origin: 'https://api-dev.bizflow.in.th',
  apiURL: isLocalhost ? 'http://localhost:5000' : 'https://api-dev.bizflow.in.th',
  images: 'https://content-dev.bizflow.in.th',
  //images: 'https://content.bizflow.in.th',
  //report: 'https://report-dev.bizflow.in.th',
  report: 'https://report-dev.bizflow.in.th',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
